import { Box, Button, FormControlLabel, Switch } from "@mui/material";
import { FC, useState } from "react";
import { P } from "theme/typography";
import NewLensDialog from "./NewLensDialog";
import { useNavigate } from "react-router";
import { useAppSelector } from "redux/hooks";
import LensCard from "routes/lenses/LensCard";
import { Link } from "react-router-dom";
import { selectLensEditorLenses } from "redux/slices/lensEditor";

const LensEditorLenses: FC = () => {
  const [openNewLens, setOpenNewLens] = useState<boolean>(false);
  const [showHiddenLenses, setShowHiddenLenses] = useState<boolean>(false); // New state variable
  const navigate = useNavigate();
  const { visibleLenses, hiddenLenses } = useAppSelector(selectLensEditorLenses);

  return (
    <Box
      sx={{
        display: "grid",
        rowGap: "32px",
        gridTemplateRows: "0 repeat(4, auto)",
        p: 2,
      }}>
      <div></div>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <P variant="h3">Lens Editor</P>
        <Box sx={{ flexGrow: 1 }}></Box>
        <Box
          sx={{
            display: "flex",
            gap: 1,
          }}>
          <FormControlLabel // New Switch component
            control={<Switch checked={showHiddenLenses} onChange={() => setShowHiddenLenses(!showHiddenLenses)} />}
            label="Show Hidden Lenses"
          />
          <Link to="stats">
            <Button variant="outlined" color="default">
              View Infra Stats
            </Button>
          </Link>
          <Button variant="outlined" color="default" onClick={() => setOpenNewLens(true)}>
            New Lens
          </Button>
        </Box>
        {openNewLens && <NewLensDialog open={openNewLens} close={() => setOpenNewLens(false)} />}
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          flexDirection: "column",
        }}>
        {visibleLenses.map((lens) => (
          <LensCard key={lens.id} lens={lens} click={() => navigate(`${lens.id}`)} isLensEditor />
        ))}
        {showHiddenLenses &&
          hiddenLenses.map((lens) => (
            <LensCard key={lens.id} lens={lens} click={() => navigate(`${lens.id}`)} isLensEditor />
          ))}
      </Box>
    </Box>
  );
};

export default LensEditorLenses;
